export function blockInviewHandler(
  type:
    | 'cta'
    | 'download'
    | 'expand'
    | 'featuredContent'
    | 'iframe'
    | 'imageGallery'
    | 'link'
    | 'linkGrid'
    | 'media'
    | 'quote'
    | 'text'
    | 'textImage'
    | 'textMore'
    | 'contactForm'
    | 'bimForm'
    | 'hubspotIframe'
    | 'header'
    | 'pageHeader'
    | 'productPageHeader'
    | 'prodDetailExpander',
  inview: boolean,
  element: string,
  inviewClass: string
): void {
  // 'type' can be used to implement different behaviour for the various buildingblocks.

  if (inview == true) {
    document.getElementById(element).classList.add(inviewClass)
  } else {
    document.getElementById(element).classList.remove(inviewClass)
  }
}
